import React from 'react';
import styles from './index.module.less';
import {Button, Classes} from "@blueprintjs/core";
import classes from 'classnames';
import axios from 'axios';
import { useHistory } from 'react-router-dom';

const PurchaseBar = ({ itemId, subItemId, price, rawPrice }) => {
  const history = useHistory();
  const handlePurchase = () => {
    axios.post('/api/mall/submit_order', {
      items: JSON.stringify([{item_id: itemId, sub_item_id: subItemId, count: 1}]),
      buy_from: 'test',
      pay_type: 201
    }).then((response) => {
      const { code, data, msg } = response.data;
      if (code === 0) {
        const { order_uuid, pay_request } = data;
        window.WeixinJSBridge.invoke('getBrandWCPayRequest', pay_request, (res) => {
          if (res.err_msg === "get_brand_wcpay_request:ok") {
            history.push('/sales/success/' + order_uuid);
          }
        });
      } else {
        console.log(msg);
      }
    });
  };
  return (
    <div className={styles['purchase-bar']}>
      <div className={styles.info}>
        <div className={styles['cur-price']}>{price}元</div>
        <div className={styles['old-price']}>原价 {rawPrice}元</div>
      </div>
      <div className={styles.action}>
        <Button className={classes(Classes.LARGE, styles.button)} onClick={handlePurchase}>立即购买</Button>
        <p>支持3天无理由退款</p>
      </div>
    </div>
  );
};

export default PurchaseBar;
